/* tslint:disable */
/* eslint-disable */
import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ContactPersonApi } from './services/contact-person-api';
import { PersonOfInteresetApi } from './services/person-of-intereset-api';
import { ScreenApi } from './services/screen-api';
import { StatisticsApi } from './services/statistics-api';
import { UserApi } from './services/user-api';
import { UsersApi } from './services/users-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    PersonOfInteresetApi,
    ScreenApi,
    StatisticsApi,
    UserApi,
    ApiConfiguration,
    ContactPersonApi,
    UsersApi
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
        'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
